import React from 'react';
import { CtaBlock } from './ui/CtaBlock';
import { BONUS_TOTAL, OFFER_ANCHOR, PACK_IMAGE, PACK_IMAGE_ALT, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-mist" data-id="element-53" data-mp="c7adc3u6m4g0">
      <div className="mx-auto max-w-xl px-4 py-4 text-center sm:py-8" data-id="element-54" data-mp="c4o665b7dqyb">
        <h2 id="cierre" className="font-display text-2xl font-extrabold text-navy sm:text-4xl" data-id="element-55" data-mp="84e3b1ipjgno">
          Una última oportunidad
        </h2>
        <p className="mt-1 text-[0.82rem] leading-snug text-navy/75 sm:text-sm" data-id="element-56" data-mp="m2lx50kg61um">
          Puedes seguir buscando actividades, diagramas, evaluaciones y proyectos cada vez que necesitas preparar una
          clase. O puedes comenzar hoy a trabajar con una biblioteca organizada de recursos para enseñar
          Electromecánica.
        </p>
        <p className="mt-1 font-display text-sm font-bold text-navy sm:text-base" data-id="element-57" data-mp="14whoc2atomi5">
          No necesitas preparar todo desde cero.{' '}
          <span className="bg-volt px-1 font-extrabold" data-id="element-58" data-mp="zua5csrks66b">
            Necesitas una estructura que puedas adaptar a tu forma de enseñar.
          </span>
        </p>

        <div className="mt-2.5 rounded-xl border-2 border-navy bg-white p-3.5" data-id="element-59" data-mp="2h4sqkjci3vuu">
          <a href={OFFER_ANCHOR} aria-label="Ir a la sección de compra" className="mx-auto block max-w-[16rem] transition-transform duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] active:scale-[0.99]" data-id="element-60" data-mp="2m2b0od298h4f">
            <img src={PACK_IMAGE} alt={PACK_IMAGE_ALT} className="block w-full" data-id="element-61" data-mp="2v1g15oxdmkj8" />
          </a>
          <p className="mt-1.5 font-condensed text-sm font-bold text-tech" data-id="element-62" data-mp="300sp6czzhxne">⚙️ {PRODUCT_NAME}</p>
          <p className="font-bebas text-2xl leading-tight tracking-wide text-navy" data-id="element-63" data-mp="34u3vmd0vwces">6 Tomos + 5 Bonos</p>
          <p className="text-sm text-navy/70" data-id="element-64" data-mp="39rnczlsvp5ay">
            Valor de los bonos:{' '}
            <span className="font-bebas text-lg tracking-wide line-through decoration-alert decoration-2" data-id="element-65" data-mp="3et2x9bn8f7sa">{BONUS_TOTAL}</span>
          </p>
          <p className="font-bebas text-5xl leading-none tracking-wide text-navy sm:text-6xl" data-id="element-66" data-mp="1joczkidfp7yn">
            Hoy: <span className="text-tech" data-id="element-67" data-mp="1ep8sbxa2lkay">{PRICE}</span>
          </p>
          <CtaBlock note="Acceso Inmediato • Entrega Digital • Garantía de 7 Días" data-id="element-68" data-mp="1er3ax4xvd0bv" />
        </div>
      </div>
    </section>;
}